import React from 'react';
import { Search } from 'lucide-react';
export const SearchInput: React.FC<{ value: string; onChange: (v: string) => void; placeholder?: string }> = ({ value, onChange, placeholder = 'Search…' }) => (
  <div className="relative w-72">
    <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted" />
    <input className="w-full pl-9 pr-3 py-2 rounded-md border border-border bg-surface text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
  </div>
);
